import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Pipe({ name: "FinalizedCombi" })
export class FinalizedCombTansform implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(value: number): string {
    return this.translateService.instant(value == 1 ? "SHARED.YES" : "SHARED.NO");
  }
}
